import { render, staticRenderFns } from "./OurTransportBannerBlock.vue?vue&type=template&id=92a7eac0&scoped=true&"
import script from "./OurTransportBannerBlock.vue?vue&type=script&lang=js&"
export * from "./OurTransportBannerBlock.vue?vue&type=script&lang=js&"
import style0 from "./OurTransportBannerBlock.vue?vue&type=style&index=0&id=92a7eac0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a7eac0",
  null
  
)

export default component.exports